// Using this history object allows us to modify history outside of the <Link> elements, etc
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
